<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import ZlgCloudHelper from './native/zlgcloudhelper.js'
import { ZWSProject } from './native/ZWSProject.js'
import { Theme } from '../third_party/common_app/Common/ZWSUtils/theme.js'
export default {
  name: 'App',
  created () {
    ZlgCloudHelper(this, {
      apiUrl: `${window.location.origin}/v1`,
      docUrl: `${window.location.origin}`
    })
    Theme.setThemeColor(ZWSProject.projectThemeColor)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue